import { render, staticRenderFns } from "./PreviewCard.vue?vue&type=template&id=f22a73ce&"
import script from "./PreviewCard.vue?vue&type=script&lang=ts&"
export * from "./PreviewCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports